// EmanetX partner paneli — placeholder + login iskelet.
// Tam backend baglantisi sonra: ortak login (eposta+parola) → JWT → rapor/hakedis ekranlari.

import { useState } from 'react';

export function App() {
  const [eposta, setEposta] = useState('');
  const [parola, setParola] = useState('');
  const [mesaj, setMesaj] = useState<string | null>(null);

  const gonder = (e: React.FormEvent) => {
    e.preventDefault();
    setMesaj('Partner girişi yakında — şimdilik info@emanetx.com üzerinden iletişime geçin.');
  };

  return (
    <main className="min-h-screen bg-zinc-50">
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-6 py-12">
        <header className="text-center">
          <h1 className="text-3xl font-extrabold tracking-tight text-zinc-900">
            emanet<span className="text-amber-500">x</span>
          </h1>
          <p className="mt-1 text-sm text-zinc-500">Partner Paneli</p>
        </header>

        <section className="mt-10 rounded-3xl border border-zinc-200 bg-white p-8 shadow-sm">
          <h2 className="text-xl font-extrabold text-zinc-900">Giriş Yap</h2>
          <p className="mt-1 text-sm text-zinc-500">
            Ortak hesabınla raporlarına ve hakediş kayıtlarına eriş.
          </p>

          <form onSubmit={gonder} className="mt-6 space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-zinc-600">
                E-posta
              </label>
              <input
                type="email"
                value={eposta}
                onChange={(e) => setEposta(e.target.value)}
                required
                placeholder="ornek@partner.com"
                className="mt-1 w-full rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm font-medium outline-none transition focus:border-amber-400"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-zinc-600">
                Parola
              </label>
              <input
                type="password"
                value={parola}
                onChange={(e) => setParola(e.target.value)}
                required
                placeholder="••••••••"
                className="mt-1 w-full rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm font-medium outline-none transition focus:border-amber-400"
              />
            </div>

            <button
              type="submit"
              className="w-full rounded-xl bg-amber-400 px-6 py-3 text-sm font-extrabold text-zinc-900 transition hover:bg-amber-500 active:scale-95"
            >
              Giriş Yap
            </button>
          </form>

          {mesaj && (
            <div className="mt-4 rounded-xl bg-amber-50 px-4 py-3 text-sm text-amber-800">
              {mesaj}
            </div>
          )}

          <div className="mt-6 border-t border-zinc-100 pt-4 text-xs text-zinc-400">
            <p>
              Partner olmak için bizimle iletişime geç:{' '}
              <a className="text-amber-600 hover:underline" href="mailto:info@emanetx.com">
                info@emanetx.com
              </a>
            </p>
          </div>
        </section>

        <p className="mt-6 text-center text-xs text-zinc-400">
          © {new Date().getFullYear()} EmanetX
        </p>
      </div>
    </main>
  );
}
